import React, { memo } from 'react';
import { ArrowRightIcon, DollarSignIcon } from 'lucide-react';
import { trackPurchaseClick, trackLeadEvent } from './MetaPixel';
const Hero = () => {
  const handleCTAClick = () => {
    trackPurchaseClick('hero_section');
    window.location.href = 'https://shopysv.com/products/pide-tu-gorro-anti-migrana';
  };
  const handleInfoHover = () => {
    trackLeadEvent('hero_info_hover');
  };
  return <section className="pt-0 pb-12 md:pb-20 bg-gradient-to-b from-[#f8f9ff] to-[#eef2ff]" data-id="element-199">
      <div className="container mx-auto px-4 md:px-6" data-id="element-200">
        <div className="flex flex-col md:flex-row items-center" data-id="element-201">
          <div className="md:w-1/2 mb-8 md:mb-0" data-id="element-202">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 text-[#1e293b]" data-id="element-203">
              <span className="block" data-id="element-204">El dolor no solo duele.</span>
              <span className="block" data-id="element-205">Te cuesta.</span>
            </h1>
            <p className="text-xl md:text-2xl text-[#4a5568] mb-6" data-id="element-206">
              Cada migraña te roba algo: tiempo, energía, productividad... y
              dinero. Y ni siquiera te das cuenta.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-207">
              <button className="bg-[#8b5cf6] hover:bg-[#7c3aed] text-white px-8 py-4 rounded-full text-lg font-medium transition-all transform hover:scale-105 shadow-lg flex items-center justify-center" onClick={handleCTAClick} data-id="element-208">
                Quiero mi rutina de alivio ahora{' '}
                <ArrowRightIcon size={20} className="ml-2" data-id="element-209" />
              </button>
              <div className="flex items-center text-[#4a5568]" onMouseEnter={handleInfoHover} data-id="element-210">
                <DollarSignIcon size={20} className="mr-2 text-[#8b5cf6]" data-id="element-211" />
                <span data-id="element-212">Ahorra $2,900 USD al año</span>
              </div>
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center" data-id="element-213">
            <div className="relative" data-id="element-214">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-[#8b5cf6] to-[#4ade80] rounded-2xl blur opacity-30 animate-pulse" data-id="element-215"></div>
              <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden" data-id="element-216">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cxax1UPkZhQUxg6w756oR7/imgi_1_0830_2.gif" alt="Corona de Alivio 360 - Alivia el dolor sin analgésicos" className="w-full h-auto object-cover" width="500" height="500" fetchpriority="high" data-id="element-217" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default memo(Hero);